import templateUrl from './datetimeexact.tpl.html';

angular
    .module('festzelt-os.components')
    .component('filterDatetimeExact', {
        bindings: {
            store: '<',
            col: '<',
        },
        controller() {
            this.$onInit = () => {
                this.model = _.defaultsDeep(this.store.state.filters[this.col.key] || {}, {min: '', max: ''});

                this.options = {
                    type: 'datetimeexact',
                    onChange: this.search
                }
            }

            this.search = (cur, prev) => {
                if (!_.isEqual(cur, prev)) {
                    return this.store.dispatch('filterCol', {col: this.col, value: this.model})
                }
            }
        },
        controllerAs: 'vm',
        templateUrl: templateUrl
    });



// WEBPACK FOOTER //
// ./src/app/components/state-manager/filter-field/types/filter-type-datetimeexact.js